import { Checkbox } from 'antd';
import { GrispiInputProps } from '..';
import { nullishValue } from '../../../utils/helpers';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiCheckboxInputProps = Omit<
    GrispiInputProps<'CHECKBOX'>,
    'type' | 'options' | 'isNewValueAllowed' | 'isAgentInput' | 'buttonText'
>;

const formValueType = {
    ['true']: true,
    ['false']: false
} as const;

const GrispiCheckboxInput = ({
    antdProps,
    checkboxDefaultValue,
    containerProps,
    onChange,
    value,
    ...rest
}: GrispiCheckboxInputProps) => {
    return (
        <GrispiInputContainer {...containerProps} alignment={containerProps?.alignment ?? 'checkbox'}>
            <Checkbox
                {...antdProps}
                onChange={({ target: { checked } }) => {
                    return onChange(!checked && nullishValue(checkboxDefaultValue) ? null : checked.toString());
                }}
                checked={formValueType[value] ?? null}
                {...rest}
            />
        </GrispiInputContainer>
    );
};

export default GrispiCheckboxInput;
